/**
 * Hook to consume MonsterStateContext. Lives in a separate file so MonsterStateContext.tsx
 * only exports React components and remains eligible for Fast Refresh.
 */

import { useContext } from 'react';
import { MonsterStateContext } from './MonsterStateContext';
import type { MonsterStateContextValue } from './MonsterStateContext';

export function useMonsterStateContext(): MonsterStateContextValue {
    const ctx = useContext(MonsterStateContext);
    if (!ctx) {
        throw new Error('useMonsterStateContext must be used within MonsterStateProvider');
    }
    return ctx;
}
